import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
  type PropsWithChildren,
} from 'react'

type ModalView = 'default' | 'confirm-discard-changes'

const viewContext = createContext<ModalView>('default')
const setViewContext = createContext<Dispatch<SetStateAction<ModalView>>>(() => {
  throw new Error('setView not implemented')
})

export function ModalViewStateProvider(props: PropsWithChildren) {
  const { children } = props
  const [view, setView] = useState<ModalView>('default')

  return (
    <setViewContext.Provider value={setView}>
      <viewContext.Provider value={view}>{children}</viewContext.Provider>
    </setViewContext.Provider>
  )
}

export function useCurrentView() {
  return useContext(viewContext)
}

export function useSetView() {
  return useContext(setViewContext)
}

export function useGoToDefaultView() {
  const setView = useSetView()
  return () => setView('default')
}

export function useGoToConfirmDiscardChangesView() {
  const setView = useSetView()
  return () => setView('confirm-discard-changes')
}
